import { onMounted, onBeforeUnmount, watch } from 'virtual-vue';

export function useKeyboardEvents(props, emit: (event: string, ...args: any[]) => void) {
  /** 初始化键盘失焦事件 */
  function handleKeyboardBlur() {
    watch(props, initBlurEventListener);

    /** 组件挂载时添加键盘失焦事件监听 */
    onMounted(initBlurEventListener);

    /** 组件卸载前移除键盘失焦事件监听 */
    onBeforeUnmount(removeBlurEventListener);

    /** 初始化键盘失焦事件监听 */
    function initBlurEventListener() {
      props.visible ? addBlurEventListener() : removeBlurEventListener();
    }

    /** 添加键盘失焦事件监听 */
    function addBlurEventListener() {
      document.body.addEventListener('click', handleBlur);
    }

    /** 移除键盘失焦事件监听 */
    function removeBlurEventListener() {
      document.body.removeEventListener('click', handleBlur);
    }

    /**
     * 点击非键盘区域触发事件
     * @description 返回触摸事件，用户可根据该事件获取到当前触摸到的元素，进而做进一步处理（如当前触摸到的元素不为输入框，可关闭键盘）
     * @param event 触摸事件
     */
    function handleBlur(event: Event) {
      emit('blur', event);
    }
  }

  /** 点击键盘， 阻止事件冒泡 */
  function handleContainerClick(event: Event) {
    event.stopPropagation();
  }

  /** 初始化事件 */
  function initEvents() {
    handleKeyboardBlur();
  }

  return {
    initEvents,
    handleContainerClick,
  };
}
